import { useQuery } from "@tanstack/react-query";
import axiosPrivate from "../axiosPrivate";

export const useCard = () =>
  useQuery({
    queryKey: ["virtualCards"],
    queryFn: async () => {
      const res = await axiosPrivate.get("card-mgt/cards/virtual/list");
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });

export const useGetWalletTransactionById = (transactionId) => {
  return useQuery({
    queryKey: ["customerWalletById"],
    queryFn: async () => {
      const res = await axiosPrivate.get(
        `customers/wallet-transactions/${transactionId}`
      );
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useGetWalletTransactions = ({
  page = 1,
  items_per_page = 15,
  wallet_number_or_uuid = "",
} = {}) => {
  const params = { page, items_per_page };
  if (wallet_number_or_uuid)
    params.wallet_number_or_uuid = wallet_number_or_uuid;

  return useQuery({
    queryKey: ["walletTransactions", params],
    queryFn: async () => {
      const res = await axiosPrivate.get(`customers/wallet-transactions`);
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};
